import { render, staticRenderFns } from "./DownloadContent.vue?vue&type=template&id=0ea209d8"
import script from "./DownloadContent.vue?vue&type=script&lang=js"
export * from "./DownloadContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea209d8')) {
      api.createRecord('0ea209d8', component.options)
    } else {
      api.reload('0ea209d8', component.options)
    }
    module.hot.accept("./DownloadContent.vue?vue&type=template&id=0ea209d8", function () {
      api.rerender('0ea209d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/downloadoverview/assets/vue/DownloadContent.vue"
export default component.exports